module.exports = __webpack_public_path__ + "img/electronic_electric_enabled.93d118df.svg";